import { render, staticRenderFns } from "./HomeSettings.vue?vue&type=template&id=79627e6a&scoped=true"
import script from "./HomeSettings.vue?vue&type=script&lang=js"
export * from "./HomeSettings.vue?vue&type=script&lang=js"
import style0 from "./HomeSettings.vue?vue&type=style&index=0&id=79627e6a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79627e6a",
  null
  
)

export default component.exports